

















import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Prop, Component } from 'vue-property-decorator';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import UUIFComponents from '@/shared/uuifComponent';
const cssPrefix = 'banner-card';

@Component({
  components: {
    ...UUIFComponents,
    SwButton,
  },
})

export default class SwBannerCard extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  cards: any;

  goToServices(serviceDetails: any) {
    this.$emit('goToServices', serviceDetails);
  }
}
